const m = window.require("@ember/array");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;